import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
 
import './registerServiceWorker'
import './quasar'
import {Quasar, QScrollArea, QMarkupTable, QTooltip} from 'quasar'

import sidebarnya from './components/sidebar.vue'
Vue.component('sidebarnya', sidebarnya); 
import modal_add from './components/modal/modal_add.vue'
Vue.component('modal_add', modal_add);
import modal_edit from './components/modal/modal_edit.vue'
Vue.component('modal_edit', modal_edit);
import modal_lihat from './components/modal/modal_lihat.vue'
Vue.component('modal_lihat', modal_lihat);

import modalloading from './components/modal/loading.vue'
Vue.component('modalloading', modalloading);

import modal_remove from './components/modal/modal_remove.vue'
Vue.component('modal_remove', modal_remove);

import modal_hapus_keluarga from './components/modal/modal_hapus_keluarga.vue'
Vue.component('modal_hapus_keluarga', modal_hapus_keluarga);

import modal_lihat_img from './components/modal/modal_lihat_img.vue'
Vue.component('modal_lihat_img', modal_lihat_img);
import modal_lihat_pdf from './components/modal/modal_lihat_pdf.vue'
Vue.component('modal_lihat_pdf', modal_lihat_pdf);

import modal_terima from './components/modal/modal_terima.vue'
Vue.component('modal_terima', modal_terima);

import modal_tolak from './components/modal/modal_tolak.vue'
Vue.component('modal_tolak', modal_tolak);

import modal_del_confirm from './components/modal_NEW/_modal_hapus.vue'
Vue.component('modal_del_confirm', modal_del_confirm);

import MODAL_TAMBAH from './components/modal_NEW/_MODAL_TAMBAH.vue'
Vue.component('MODAL_TAMBAH', MODAL_TAMBAH);

import MODALS from './components/modal_NEW/_MODALS.vue'
Vue.component('MODALS', MODALS);
import MODALS_RED from './components/modal_NEW/_MODALS_RED.vue'
Vue.component('MODALS_RED', MODALS_RED);

// =============================== MODAL KK ===============================
  import add_keluarga from './components/modal_kk/add_keluarga.vue'
  Vue.component('add_keluarga', add_keluarga);

  import m_example from './components/modal/m_example.vue'
  Vue.component('m_example', m_example);
  
// =============================== MODAL KK ===============================



import Autocomplete from 'vue2-autocomplete-js';
Vue.component('Autocomplete', Autocomplete);

Vue.config.productionTip = false


import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('span', '❌'),
  },
  OpenIndicator: {
    render: createElement => createElement('span', '🔽'),
  },
});


 


Vue.use(Quasar, {
  components: {QScrollArea, QMarkupTable, QTooltip}
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
